import axios from 'axios'
import { storefrontRequestConfig, STOREFRONT_URL } from '@/js/utils/api'
import { useFlyouts } from '@/js/composables/flyouts'
import { collectionNumberOfProductsQuery } from '@/js/utils/data'

export default {
  props: {
    menuItems: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      isLoading: true,
      collections: null
    }
  },

  setup () {
    const {
      flyouts,
      megamenuToggles,
      toggleFlyout,
      initMegamenu,
      closeAllMegamenus
    } = useFlyouts()

    return {
      flyouts,
      megamenuToggles,
      toggleFlyout,
      initMegamenu,
      closeAllMegamenus
    }
  },

  directives: {
    initMegamenu: {
      inserted (el, binding, vnode) {
        vnode.context.initMegamenu(el, binding, vnode)
      }
    }
  },

  async created () {
    const handles = this.menuItems
      ?.split(',')
      ?.filter((menuItem) => menuItem && menuItem.includes('/collections/'))
      ?.map((menuItem) => menuItem.replaceAll('/collections/', ''))

    this.collections = await this.getCollections(handles)
    this.isLoading = false
  },

  methods: {
    async getCollections (handles) {
      let query = ''

      handles.forEach(handle => {
        query += `title:'${handle}'`
        query += ' OR '
      })

      const data = `{
        collections(query: "${query}", first: 50) {
          ${collectionNumberOfProductsQuery}
        }
      }`

      // eslint-disable-next-line no-undef
      return await axios.post(STOREFRONT_URL, data, storefrontRequestConfig).then(({ data }) => {
        return data.data.collections.edges.map(edge => edge.node)
      }).catch((error) => {
        console.log('Collections products', error)
        throw error
      })
    },

    getNumberOfProducts (url) {
      if (!this.isCollectionUrl(url) || !this.collections) return 0

      const handle = url.replaceAll('/collections/', '')
      const respectiveCollection = this.collections?.find((collection) => collection.handle === handle)

      if (!respectiveCollection?.products?.edges) return 0
      return respectiveCollection?.products?.edges?.length
    },

    isCollectionUrl (url) {
      return url?.includes('/collections/')
    }
  }
}
